import $ from "jquery"
import '.././less/plugin-twitter.less'

import TwitterAddTemplate from 'raw-loader!.././templates/twitter-add.html'
import FluxEditorEvents from '../events'
import FluxEditorTooltip from '../tooltip'

function FluxEditorTwitter(options) {
  this.defaults = {
    addTemplate: TwitterAddTemplate,
    selectors: ['figure[class~="flux-twitter"]'],
    identifier: 'flux-editor-twitter',
    tooltipItemTitle: 'New Tweet',
    formPlaceholderText: 'Copy/paste Twitter short url here and press enter (esc to cancel)',
    events: {
      onNewElement: function (args) { return args }
    }
  }
  this.settings = Object.assign({}, this.defaults, options)

  FluxEditorEvents(this)
  this.registerEvents()
}

FluxEditorTwitter.prototype.getSelectors = function () {
  return this.settings.selectors
}

FluxEditorTwitter.prototype.getIdentifier = function () {
  return this.settings.identifier
}

FluxEditorTwitter.prototype.registerEvents = function () {
  var _this = this
  if (typeof this.settings.events == 'object') {
    $.each(this.settings.events, function (i, f) {
      _this.on(i, f)
    })
  }
}

FluxEditorTwitter.prototype.getTooltipItem = function (context) {
  return {
    title: this.settings.tooltipItemTitle,
    className: 'flux-editor-twitter-tooltip-item',
    plugin: this,
    method: 'addNewElement',
    arguments: context
  }
}

FluxEditorTwitter.prototype.addNewElement = function (args) {
  args.core.insertNewEditableContentAfter(args.fluxElementIndex, this, {
    html: '',
  })
}

FluxEditorTwitter.prototype.getContent = function (el) {
  return {
    html: el.innerHTML,
  }
}

FluxEditorTwitter.prototype.getHTML = function (content, core) {
  this.___core = core
  return `<figure class="flux-twitter">${content.html}</figure>`
}

FluxEditorTwitter.prototype.getEditableElement = function (content, core) {
  if (!content.html.trim()) {
    var $el = $(this.settings.addTemplate)
    var $input = $el.find('.flux-editor-twitter-src')
    var $cancel = $el.find('.flux-editor-twitter-cancel')

    $input.attr('placeholder', this.settings.formPlaceholderText)
    $input.keyup(function (e) {
      // Sample https://twitter.com/twipsum/status/13007058604
      if (e.keyCode == 13) {
        var src = $(this).val()
        if (src) {
          $.ajax({
            url: 'https://api.twitter.com/1/statuses/oembed.json?align=center&url='+src,
            dataType: "jsonp",
            success: function (data){
              if (data.html) {
                content.html = data.html
                core.renderEditableContent(content.fluxElementIndex)
              }
            }
          })
        }
      }

      if (e.keyCode == 27) { // esc
        core.deleteEditableContent(content.fluxElementIndex)
      }
    })

    $cancel.click(function () {
      core.deleteEditableContent(content.fluxElementIndex)
    })

    setTimeout(function () {
      $input.focus()
    }, 500)

  } else {
    $el = $('<figure class="flux-editor-twitter"><div class="flux-editor-twitter-mask"></div></figure>').append(content.html)
    $el.css('min-height', 220)
    var $mask = $el.find('.flux-editor-twitter-mask')

    $mask.click(function (){
      var tooltip = new FluxEditorTooltip()

      // move
      tooltip.addItem({
        className: 'flux-editor-twitter-tooltip-arrowup',
        callback: function () {
          core.moveEditableContent(content.fluxElementIndex, 'up')
        }
      })
      tooltip.addItem({
        className: 'flux-editor-twitter-tooltip-arrowdown',
        callback: function () {
          core.moveEditableContent(content.fluxElementIndex, 'down')
        }
      })

      // remove
      tooltip.addItem({
        className: 'flux-editor-twitter-tooltip-trash',
        callback: function () {
          core.deleteEditableContent(content.fluxElementIndex)
        }
      })

      tooltip.display(
        $mask.offset().top + ($mask.height() - 72),
        $mask.offset().left + ($mask.width() / 2),
        true
      )
    })
  }

  return $el
}

export default FluxEditorTwitter
